import { Navigate, Outlet } from "react-router";
import { ROLE, useFoodpilotContext } from "src/context/FoodpilotContext";
import type { Slugs } from "src/context/ProtectedContext";

type RolesProtectionProps = {
    action: Slugs;
};

export const RolesProtection = (props: RolesProtectionProps) => {
    const { canUser } = useFoodpilotContext();

    if (!canUser(props.action, ROLE)) {
        return <Navigate to="/settings" replace />;
    }

    return <Outlet />;
};
